import AuthContext from 'context/AuthProvider';
import { useContext } from 'react';

const BOT_UA =
  /bot|crawl|spider|slurp|headless|lighthouse|render|gptbot|claudebot|bytespider|tiktokspider|baiduspider|adsbot|perplexity|amazonbot|petalbot|ahrefs|semrush|dataforseo|facebookexternalhit|phantomjs|puppeteer|playwright/i;

function isLikelyBot() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return true;
  if (navigator.webdriver) return true; // Catches headless automated scrapers
  if (BOT_UA.test(navigator.userAgent)) return true; // Catches all specific bot UAs case-insensitively
  if (!navigator.cookieEnabled) return true; // Prevents cookie-less single-hit MTU inflation
  return false;
}

const useSegment = () => {
  const auth = useContext(AuthContext);

  const identify = () => {
    if (!window.navigator.userAgent.includes('Googlebot') && !isLikelyBot()) {
      if (auth?.state?.customerId) {
        window.analytics?.identify(auth.state.customerId, {
          email: auth.state.email,
          name: auth.state.object
            ? auth.state.object?.first_name + ' ' + auth.state.object?.last_name
            : 'Guest'
        });
      } else {
        window.analytics?.identify({
          email: ''
        });
      }
    }
  };
  const identifyManual = props => {
    if (!window.navigator.userAgent.includes('Googlebot') && !isLikelyBot()) {
      let segmentData = {};

      if (auth?.state?.customerId) {
        segmentData = {
          customerId: auth.state.customerId,
          email: auth.state.email,
          name: auth.state.object
            ? auth.state.object?.first_name + ' ' + auth.state.object?.last_name
            : 'Guest'
        };
      }

      segmentData = {
        ...segmentData,
        ...props
      };

      const anonymousId = segmentData?.anonymousId || undefined;
      delete segmentData.anonymousId;
      window.analytics?.identify(segmentData.customerId || anonymousId, segmentData);
    }
  };

  const track = async (event, properties, options = {}) => {
    if (!window.navigator.userAgent.includes('Googlebot') && !isLikelyBot()) {
      if (properties) {
        window.analytics?.track(event, properties, options);
      }
    }
  };

  return { track, identify, identifyManual };
};

export default useSegment;
